import {Button, Divider, Stack, styled, Typography} from '@mui/material';

const StyledTypographyTitle = styled(Typography)`
	color: ${({theme}) => theme.colors.light.primary.main};
	font-weight: 600;
	line-height: 1.2;
	letter-spacing: 0.15px;
`;

const StyledDivider = styled(Divider)`
	margin: 8px 0 16px;
`;

const StyledTelemedicineCard = styled(Stack)`
	flex-direction: row;
	gap: 8px;
	align-items: center;
	margin-bottom: 16px;
`;

const StyledSmallButton = styled(Button)`
	align-self: flex-end;
	margin-top: auto;
	text-transform: none;
	padding: 4px 10px;
	.MuiButton-endIcon {
		margin-left: 4px;
	}
`;

const StyledSeeMap = styled(Typography)`
	width: fit-content;
	font-size: 14px;
	font-weight: 400;
	color: ${({theme}) => theme.palette.primary.main};
	cursor: pointer;
`;

export {
	StyledTypographyTitle,
	StyledDivider,
	StyledTelemedicineCard,
	StyledSmallButton,
	StyledSeeMap,
};
